export default "__VITE_ASSET__BbnSkg3a__"